import { useEffect } from 'react';
import { useDataFetchingClient, useQuery } from 'data-fetching-client';
import { EMBED_MESSAGE_TYPES } from 'payments-checkout-lib/constants/Embed';
import { useIframeableContext } from '../context/IframeableContext';
import { GET_CHECKOUT_SESSION } from '../data/queries';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewCheckoutContainer = ({
  children
}) => {
  var _iframeableContext$pa;
  const client = useDataFetchingClient();
  const iframeableContext = useIframeableContext();
  const embeddedCheckoutSession = iframeableContext === null || iframeableContext === void 0 || (_iframeableContext$pa = iframeableContext.passthruProps) === null || _iframeableContext$pa === void 0 ? void 0 : _iframeableContext$pa.checkoutSession;
  useEffect(() => {
    if (embeddedCheckoutSession && embeddedCheckoutSession.id) {
      client.writeQuery({
        query: GET_CHECKOUT_SESSION,
        data: {
          checkoutSession: embeddedCheckoutSession
        }
      });
    } else if (iframeableContext) {
      iframeableContext.sendMessage(EMBED_MESSAGE_TYPES.MISSING_CHECKOUT_SESSION);
    } else {
      console.error('PreviewContainer: iframeableContext is null — component must be rendered within IframeableContainer');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const {
    data
  } = useQuery(GET_CHECKOUT_SESSION, {
    fetchPolicy: 'cache-only'
  });
  const cachedCheckoutSession = data && data.checkoutSession;
  if (!cachedCheckoutSession) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    minHeight: 200
  });
  return children;
};
export default PreviewCheckoutContainer;